export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0031s_0000_Black-&-White-18.8a3a0c9e.png";